import { useState, useEffect } from 'react';

export function teamMembersLimit(ownerPlan) {
  if (ownerPlan === 'free') return 3;
  if (ownerPlan === 'pro') return 10;
  return null; // unlimited
}

export function memberCountDisplay(count, ownerPlan) {
  const limit = teamMembersLimit(ownerPlan);
  return limit ? `${count} / ${limit} members` : `${count} ${count === 1 ? 'member' : 'members'}`;
}

// ─── dark-mode hook ───────────────────────────────────────────────────────────
export function useDark() {
  const [isDark, setIsDark] = useState(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
  );
  useEffect(() => {
    const obs = new MutationObserver(() =>
      setIsDark(document.documentElement.classList.contains('dark'))
    );
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);
  return isDark;
}

// ─── design tokens ────────────────────────────────────────────────────────────
export const DARK = {
  bg:         '#161618',
  card:       '#222226',
  cardHover:  '#26262a',
  border:     '#2e2e34',
  inputBg:    '#1c1c20',
  text:       '#ffffff',
  textSub:    '#a1a1ab',
  textMuted:  '#6b6b75',
  hover:      '#28282e',
  divider:    '#26262c',
  sectionBg:  '#1e1e22',
  chip:       '#2a2a30',
  chipBorder: '#38383f',
  chipText:   '#a1a1ab',
  amber:      '#f59e0b',
  red:        '#f87171',
  shadow:     '0 8px 32px rgba(0,0,0,0.45)',
};

export const LIGHT = {
  bg:         '#f5f5f7',
  card:       '#ffffff',
  cardHover:  '#f9f9fb',
  border:     '#e4e4e8',
  inputBg:    '#ffffff',
  text:       '#111114',
  textSub:    '#52525b',
  textMuted:  '#9898a5',
  hover:      '#f4f4f6',
  divider:    '#f0f0f2',
  sectionBg:  '#f8f8fa',
  chip:       '#f1f1f4',
  chipBorder: '#d8d8de',
  chipText:   '#52525b',
  amber:      '#d97706',
  red:        '#dc2626',
  shadow:     '0 8px 32px rgba(0,0,0,0.12)',
};

// ─── colour helpers ───────────────────────────────────────────────────────────
export const PALETTE = [
  '#ef4444','#f97316','#f59e0b','#eab308',
  '#22c55e','#14b8a6','#3b82f6','#8b5cf6',
  '#ec4899','#6366f1',
];

export function teamColor(team) {
  if (team?.color) return team.color;
  let h = 0;
  for (const c of (team?.name || '')) h = c.charCodeAt(0) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
}

export function dk(hex, a = 0.3) {
  const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
  const f = v => Math.max(0,Math.round(v*(1-a))).toString(16).padStart(2,'0');
  return `#${f(r)}${f(g)}${f(b)}`;
}
